var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboard({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.2915 5.95817C2.2915 4.22969 2.2915 3.36545 2.82847 2.82847C3.36545 2.2915 4.22969 2.2915 5.95817 2.2915C7.68665 2.2915 8.5509 2.2915 9.08787 2.82847C9.62484 3.36545 9.62484 4.22969 9.62484 5.95817C9.62484 7.68665 9.62484 8.5509 9.08787 9.08787C8.5509 9.62484 7.68665 9.62484 5.95817 9.62484C4.22969 9.62484 3.36545 9.62484 2.82847 9.08787C2.2915 8.5509 2.2915 7.68665 2.2915 5.95817Z",
    stroke: "#949494",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.375 16.0417C12.375 14.3132 12.375 13.4489 12.912 12.912C13.4489 12.375 14.3132 12.375 16.0417 12.375C17.7702 12.375 18.6344 12.375 19.1714 12.912C19.7083 13.4489 19.7083 14.3132 19.7083 16.0417C19.7083 17.7702 19.7083 18.6344 19.1714 19.1714C18.6344 19.7083 17.7702 19.7083 16.0417 19.7083C14.3132 19.7083 13.4489 19.7083 12.912 19.1714C12.375 18.6344 12.375 17.7702 12.375 16.0417Z",
    stroke: "#949494",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.2915 16.0417C2.2915 14.3132 2.2915 13.4489 2.82847 12.912C3.36545 12.375 4.22969 12.375 5.95817 12.375C7.68665 12.375 8.5509 12.375 9.08787 12.912C9.62484 13.4489 9.62484 14.3132 9.62484 16.0417C9.62484 17.7702 9.62484 18.6344 9.08787 19.1714C8.5509 19.7083 7.68665 19.7083 5.95817 19.7083C4.22969 19.7083 3.36545 19.7083 2.82847 19.1714C2.2915 18.6344 2.2915 17.7702 2.2915 16.0417Z",
    stroke: "#949494",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.375 5.95817C12.375 4.22969 12.375 3.36545 12.912 2.82847C13.4489 2.2915 14.3132 2.2915 16.0417 2.2915C17.7702 2.2915 18.6344 2.2915 19.1714 2.82847C19.7083 3.36545 19.7083 4.22969 19.7083 5.95817C19.7083 7.68665 19.7083 8.5509 19.1714 9.08787C18.6344 9.62484 17.7702 9.62484 16.0417 9.62484C14.3132 9.62484 13.4489 9.62484 12.912 9.08787C12.375 8.5509 12.375 7.68665 12.375 5.95817Z",
    stroke: "#949494",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.0ec157a657d3efaa341f7044fa48faeb.svg";
export { ForwardRef as ReactComponent };